import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import CustomizedCheckbox from "commonComponents/FormElement/Checkbox";
import VolumeDownIcon from "assets/svgIcons/VolumeDownIcon";
import CloudIcon from "assets/svgIcons/CloudIcon";
import BlindShotIcon from "assets/svgIcons/BlindShotIcon";
import UserIcon from "assets/svgIcons/UserIconCircle";
import HideIcon from "assets/svgIcons/BenIcon";
import PlayIcon from "assets/svgIcons/AutoPlayIcon";
import HeatMapIcon from "assets/svgIcons/HeatMapIcon";
import {
    getFeatureSetOption,
    getFeaturesList,
    isUserBasic,
    isUserReadOnly
} from "../../../../constant";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import {
    Heading,
    WorkSection,
    CheckBoxWrapper,
    ActionWrapper
} from "pages/Fleet/Settings/SettingsStyled";
import SelectStyled from "commonComponents/FormElement/Select";
import { Loader } from "commonComponents/Loader/Loader";
import { useHookstate } from "@hookstate/core";
import { CenteredLoader } from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import { CHECKBOX_LOADER, MAX_VOLUME_ALLOWED
} from "globalStore/globalStore";
import { useSelector } from "react-redux";
import { WeatherCheckbox } from "commonComponents/FormElement/Checkbox/WeatherCheckbox";
import { Button } from "@mui/material";
import "react-quill/dist/quill.snow.css";

export const GeneralAccordion = ({handleTextRoundManagementOnSave, handleTextRoundManagementOnReset}) => {
    const { t } = useTranslation();

    const { generalTabLoader } = useHookstate(CHECKBOX_LOADER);

    const { siteSettingsData, getUserRole } = useSelector((state) => state?.commonReducers) || [];

    const { maxVolumeAllowed, maxVolumeOptionTriggered } = useHookstate(MAX_VOLUME_ALLOWED);

    // Maximum Volume Allowed Options
    const maxVolumeAllowedOptions = [
        {
            value: "Mute",
            label: t("Mute"),
        },
        {
            value: "Low",
            label: t("Low"),
        },
        {
            value: "Medium",
            label: t("Medium"),
        },
        {
            value: "High",
            label: t("High"),
        },
    ];

    return (
        <>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Heading>
                        <h3>{t("General")}</h3>
                    </Heading>
                </AccordionSummary>
                <AccordionDetails>
                    <WorkSection className="fleet-general-tab">
                        <>
                            {generalTabLoader.get() && (
                                <CenteredLoader className="innerSectionLoader">
                                    <Loader />
                                </CenteredLoader>
                            )}
                            <div>
                                <CheckBoxWrapper>
                                    <WeatherCheckbox
                                        identification="WA"
                                        disabledState={isUserReadOnly(
                                            getUserRole && getUserRole?.Role
                                        )}
                                    />
                                    <CloudIcon />
                                </CheckBoxWrapper>
                            </div>
                            <div>
                                <CheckBoxWrapper>
                                    <CustomizedCheckbox
                                        identification="SD"
                                        label={t("Hide_distances")}
                                        name="Hide Distances"
                                        lockdownText="hideDistance"
                                        width={15}
                                        height={15}
                                        disabled={
                                            getFeatureSetOption(
                                                siteSettingsData?.Features,
                                                getFeaturesList().golfer_experience
                                            ) || isUserReadOnly(getUserRole?.Role)
                                        }
                                    />
                                    <HideIcon className="cloud-icon" />
                                </CheckBoxWrapper>
                            </div>


                            <div>
                                <CheckBoxWrapper>
                                    <CustomizedCheckbox
                                        identification="BS"
                                        label={t("Blind_shots")}
                                        name="Blind Shot"
                                        lockdownText="blindShots"
                                        width={15}
                                        height={15}
                                        disabled={
                                            getFeatureSetOption(
                                                siteSettingsData?.Features,
                                                getFeaturesList().golfer_experience
                                            ) || isUserReadOnly(getUserRole?.Role)
                                        }
                                    />
                                    <BlindShotIcon className="cloud-icon" />
                                </CheckBoxWrapper>
                            </div>
                            <div>
                                <CheckBoxWrapper>
                                    <CustomizedCheckbox
                                        identification="AF"
                                        label={t("Auto-play_flyovers")}
                                        name="Auto-play flyovers"
                                        lockdownText="autoplay"
                                        width={15}
                                        height={15}
                                        disabled={
                                            getFeatureSetOption(
                                                siteSettingsData?.Features,
                                                getFeaturesList().flyovers,
                                            ) || isUserReadOnly(getUserRole?.Role)
                                        }
                                    />
                                    <PlayIcon className="cloud-icon" />
                                </CheckBoxWrapper>
                            </div>
                            <div>
                                <CheckBoxWrapper>
                                    <CustomizedCheckbox
                                        disabled={getFeatureSetOption(
                                            siteSettingsData?.Features,
                                            getFeaturesList().golfer_experience
                                        ) || isUserReadOnly(getUserRole?.Role)}
                                        identification="SH"
                                        label={t("Show_names_on_Welcome_Screen")}
                                        name="Show names on welcome screen"
                                        lockdownText="showNames"
                                        width={15}
                                        height={15}
                                    />
                                    <UserIcon className="cloud-icon" />
                                </CheckBoxWrapper>
                            </div>
                            <div>
                                <CheckBoxWrapper>
                                    <CustomizedCheckbox
                                        disabled={getFeatureSetOption(
                                            siteSettingsData?.Features,
                                            getFeaturesList().golfer_experience
                                        ) || isUserReadOnly(getUserRole?.Role)}
                                        identification="YE"
                                        label={t("Show_Plays_Like_Yardage")}
                                        name="Show plays like yardage"
                                        lockdownText="playsLikeYardage"
                                        width={15}
                                        height={15}
                                    />
                                    <UserIcon className="cloud-icon" />
                                </CheckBoxWrapper>
                            </div>
                            <div className="select-wrapper">
                                <p className="label text-with-icon">
                                    <VolumeDownIcon />
                                    {t("Max_volume_allowed")}
                                </p>
                                <SelectStyled
                                    disabled={isUserReadOnly(getUserRole?.Role)}
                                    value={maxVolumeAllowed.get()}
                                    data={maxVolumeAllowedOptions}
                                />
                                <ActionWrapper>
                                    <Button
                                        variant="outlined"
                                        disabled={isUserReadOnly(getUserRole?.Role)}
                                        onClick={() => handleTextRoundManagementOnSave("max_volume_allowed")}
                                        className={
                                            maxVolumeOptionTriggered.get() ? "active" : "disabled"
                                        }
                                    >
                                        {t("Save")}
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        disabled={isUserReadOnly(getUserRole?.Role)}
                                        className="send-btn"
                                        onClick={() => handleTextRoundManagementOnReset("max_volume_allowed")}
                                    >
                                        {t("Reset")}
                                    </Button>
                                </ActionWrapper>
                            </div>
                            {
                                <div>
                                    <CheckBoxWrapper>
                                        <CustomizedCheckbox
                                            identification="GV"
                                            label={t("Heatmap")}
                                            name="Heatmap"
                                            lockdownText="Heatmap"
                                            width={15}
                                            height={15}
                                            disabled={isUserReadOnly(getUserRole && getUserRole?.Role) || isUserBasic(getUserRole && getUserRole?.Role)}
                                        />
                                        <HeatMapIcon className="cloud-icon" />
                                    </CheckBoxWrapper>
                                </div>
                            }

                        </>
                    </WorkSection>
                </AccordionDetails>
            </Accordion>
        </>
    );
};